import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSmartModalComponent, NgxSmartModalService } from 'ngx-smart-modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { AbstractBaseComponent } from 'src/app/model/AbstractBaseComponent';
import { GetProveEsamiDisponibiliCommand } from 'src/app/model/command-model';
import { StudenteDTO } from 'src/app/model/newModel';

import { SharedService } from '../../../shared/shared.service';
import {
  EsitoTest,
  ListProveFinaliDTO,
  PercentualiStudio,
} from './../../../model/newModel';
import { HomeService } from './home.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})
export class HomeComponent
  extends AbstractBaseComponent
  implements AfterViewInit, OnInit, OnDestroy {
  esitoTestPlacement: EsitoTest = new EsitoTest();
  percentualiStudio: PercentualiStudio = new PercentualiStudio();
  studente: StudenteDTO;
  allPercentualiStudioCompletate: boolean;
  provaEsameDisponibile: boolean;
  contatore = 0;
  proveEsami: ListProveFinaliDTO;
  gruppoStudioActive: boolean;
  obbligoOrale: boolean;
  showPrenotazioneProvaFinale: boolean;
  showPrenotazioneProvaFinaleEsonerato: boolean;
  showDownloadAttestato: boolean;
  verificaSelfStudy = true;
  disabilitaPrenotazione = true;
  descrizioneLaboratorio: String;
  descrizioneAula: String;
  descrizioneSelfStudy: String;
  alertCacheVisited = false;
  alertAnomaliaVisited = false;

  close(event: any) {
    sessionStorage.setItem(event, 'true');
    this.alertCacheVisited = JSON.parse(sessionStorage.getItem('alertCache'));
    this.alertAnomaliaVisited = JSON.parse(
      sessionStorage.getItem('alertAnomalia')
    );
  }

  verifyFile(file: File) {
    if (
      file &&
      file.name.toLowerCase().indexOf('.pdf') <= 0 &&
      file.name.toLowerCase().indexOf('.doc') <= 0 &&
      file.name.toLowerCase().indexOf('.docx') <= 0
    ) {
      this.sharedService.openKoModal();
    } else {
      // aspetto 5 secondi e ricarico chiamando il backend per recuperare i nuovi dati
      setTimeout(() => {
        if (this.contatore === 0) {
          this.homeService
            .getFileAgendaStudioStudente(this.studente.sessioneOlaStudente.id)
            .subscribe(
              (result) => {
                const reader = new FileReader();
                const s = reader.readAsDataURL(result);
                this.studente.sessioneOlaStudente.agendaStudioAutonomia = true;
                sessionStorage.setItem(
                  'currentUser',
                  JSON.stringify(this.currentUser)
                );
                this.sharedService.openOkModal();
                this.modalSubscribe = this.ngxSmartModalService
                  .getModal('okModal')
                  .onClose.subscribe((modal: NgxSmartModalComponent) => {
                    window.location.reload();
                  });
              },
              (error) => {
                this.sharedService.openKoModal();
              }
            );
          this.contatore++;
        }
      }, 500);
    }
  }

  scaricaAttestato() {
    this.spinner.show();
    this.sharedService
      .generaAttestato(this.studente.id, this.studente.sessioneOla.id)
      .subscribe(
        (result) => {
          const downloadURL = window.URL.createObjectURL(result);
          const link = document.createElement('a');
          link.href = downloadURL;
          link.download =
            this.studente.nome +
            '_' +
            this.studente.cognome +
            '_ATTESTATO.pdf';
          link.click();
          this.spinner.hide();
        },
        (error) => {
          this.spinner.hide();
          console.log('Errore genera attestato:' + error);
        }
      );
  }

  abilitaOraleFacoltativo() {
    this.homeService
      .abilitaOraleFacoltativo(this.studente.sessioneOlaStudente.id, true)
      .subscribe(
        (result) => {
          const text =
            'Operazione effettuata correttamente! Questa operazione prevede di effettuare di nuovo il login!';
          this.sharedService.openOkModal(text);
          this.modalSubscribe = this.ngxSmartModalService
            .getModal('okModal')
            .onClose.subscribe((modal: NgxSmartModalComponent) => {
              sessionStorage.clear();
              localStorage.clear();
              this.router.navigate(['/login']);
            });
        },
        (error) => {
          this.sharedService.openKoModal();
        }
      );
  }

  ngOnInit(): void {
    this.currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    this.alertCacheVisited = JSON.parse(sessionStorage.getItem('alertCache'));
    this.alertAnomaliaVisited = JSON.parse(
      sessionStorage.getItem('alertAnomalia')
    );
    console.log(this.currentUser);
    if (this.currentUser.tipoStudente) {
      this.studente = this.currentUser.studente;
      this.obbligoOrale = this.studente.corsoLaurea.obbligoOrale;
      if (!!this.studente.gruppoStudio && this.studente.gruppoStudio.active) {
        this.loadEsitoTestPlacement();
        this.loadPercentualiStudio();
        this.loadProveEsamiDisponibili();
        this.gruppoStudioActive = true;
      } else if (
        !!this.studente.gruppoStudio &&
        !this.studente.gruppoStudio.active
      ) {
        this.gruppoStudioActive = false;
      }

      // SHOW PRENOTAZIONE PROVA FINALE
      this.showPrenotazioneProvaFinale =
        !this.studente.sessioneOlaStudente.esonerato &&
        (!!this.studente.gruppoStudio && this.studente.sessioneOlaStudente.votoProvaFinale <
          this.studente.gruppoStudio.votoMinimoSuperamentoProvaFinale ||
          (!!this.studente.gruppoStudio && this.studente.sessioneOlaStudente.votoProvaFinale >=
            this.studente.gruppoStudio.votoMinimoSuperamentoProvaFinale &&
            this.studente.sessioneOlaStudente.oraleFacoltativo));

      this.showPrenotazioneProvaFinaleEsonerato =
        this.studente.sessioneOlaStudente.esonerato &&
        (!!this.studente.gruppoStudio && this.studente.sessioneOlaStudente.votoProvaFinale <
          this.studente.gruppoStudio.votoMinimoSuperamentoProvaFinale ||
          (!!this.studente.gruppoStudio && this.studente.sessioneOlaStudente.votoProvaFinale >=
            this.studente.gruppoStudio.votoMinimoSuperamentoProvaFinale &&
            this.studente.sessioneOlaStudente.oraleFacoltativo));

      this.showDownloadAttestato =
      this.studente.sessioneOlaStudente.note != "STORICO OLA" && (
        (!!this.studente.gruppoStudio && this.studente.sessioneOlaStudente.votoProvaFinale >=
          this.studente.gruppoStudio.votoMinimoSuperamentoProvaFinale &&
          !this.studente.sessioneOlaStudente.oraleFacoltativo) ||
          !!this.studente.gruppoStudio && this.studente.sessioneOlaStudente.votoProvaFinale >=
          this.studente.gruppoStudio.votoMinimoSuperamentoProvaFinale);
    }
  }

  loadEsitoTestPlacement() {
    // SERVIZIO PER RECUPERARE ESITO PLACEMENTE TEST
    this.homeService.esitoPlacementTest(this.currentUser.studente.id).subscribe(
      (result) => {
        this.esitoTestPlacement = result;
      },
      (error) => {
        console.log('Errore recupero esito placement test');
      }
    );
  }

  loadPercentualiStudio() {
    // RECUPERO PERCENTUALI STUDIO
    this.homeService.percentualiStudio(this.currentUser.studente.id).subscribe(
      (result) => {
        this.percentualiStudio = result;
        this.calcolaDescrizioniPercentualiStudio(result);

        const laboratorioCompletato =
          (Number(this.percentualiStudio.laboratorio.percentualeCorrente) !==
            0 &&
            Number(this.percentualiStudio.laboratorio.percentualeCorrente) >=
              Number(
                this.percentualiStudio.laboratorio.percentualeSuperamento
              )) ||
          this.studente.sessioneOlaStudente.esoneroOreInLaboratorio;

        const lezioniInAulaCompletato =
          (Number(this.percentualiStudio.lezioniInAula.percentualeCorrente) !==
            0 &&
            Number(this.percentualiStudio.lezioniInAula.percentualeCorrente) >=
              Number(
                this.percentualiStudio.lezioniInAula.percentualeSuperamento
              )) ||
          this.studente.sessioneOlaStudente.esoneroOreInAula;

        const selfStudyCompletato =
          (Number(this.percentualiStudio.selfStudy.percentualeCorrente) !== 0 &&
            Number(this.percentualiStudio.selfStudy.percentualeCorrente) >=
              Number(
                this.percentualiStudio.selfStudy.percentualeSuperamento
              )) ||
          this.studente.sessioneOlaStudente.esoneroAgendaStudio;
        this.allPercentualiStudioCompletate =
          laboratorioCompletato &&
          lezioniInAulaCompletato &&
          selfStudyCompletato;

        this.verificaSelfStudy =
          this.studente.sessioneOlaStudente.esoneroAgendaStudio ||
          (Number(this.percentualiStudio.selfStudy.percentualeSuperamento) !== 0
            ? this.studente.sessioneOlaStudente.agendaStudioAutonomiaVerificata
            : true);
      },
      (error) => {
        console.log('Errore recupero percentuali studio');
      }
    );
  }

  private calcolaDescrizioniPercentualiStudio(percStudio: PercentualiStudio) {
    // tslint:disable-next-line: max-line-length
    const oreDaRaggiungereLaboratorio =
      percStudio.laboratorio.oreMinimeTotali === 0
        ? percStudio.laboratorio.oreTotali
        : percStudio.laboratorio.oreMinimeTotali;
    // tslint:disable-next-line: max-line-length
    const oreDaRaggiungereAula =
      percStudio.lezioniInAula.oreMinimeTotali === 0
        ? percStudio.lezioniInAula.oreTotali
        : percStudio.lezioniInAula.oreMinimeTotali;
    // tslint:disable-next-line: max-line-length
    const oreDaRaggiungereSelfStudy =
      percStudio.selfStudy.oreMinimeTotali === 0
        ? percStudio.selfStudy.oreTotali
        : percStudio.selfStudy.oreMinimeTotali;

    // tslint:disable-next-line: max-line-length
    this.descrizioneLaboratorio =
      // oreDaRaggiungereLaboratorio > 0
      //   ? 'Raggiungi ' +
      //     oreDaRaggiungereLaboratorio +
      //     ' ore per sostenere la prova finale'
      //   : '';
      oreDaRaggiungereLaboratorio > 0
        ? 'Raggiungi ' +
          percStudio.laboratorio.viewOreMinimeTotali +
          ' ore per sostenere la prova finale'
        : '';
    // this.descrizioneAula =
    //   oreDaRaggiungereAula > 0
    //     ? 'Raggiungi ' +
    //       oreDaRaggiungereAula +
    //       ' ore per sostenere la prova finale'
    //     : '';
    this.descrizioneAula =
      oreDaRaggiungereAula > 0
        ? 'Raggiungi ' +
        percStudio.lezioniInAula.viewOreMinimeTotali +
          ' ore per sostenere la prova finale'
        : '';
    // tslint:disable-next-line: max-line-length
    this.descrizioneSelfStudy =
      oreDaRaggiungereSelfStudy > 0
        ? 'Raggiungi ' +
          oreDaRaggiungereSelfStudy +
          ' ore per sostenere la prova finale'
        : '';
  }

  loadProveEsamiDisponibili() {
    const esameEffettuato = !(!this.studente.sessioneOlaStudente.votoProvaFinale ||
    this.studente.sessioneOlaStudente.votoProvaFinale === 0);
    const esameSuperato = !(!!this.studente.gruppoStudio &&
    !!this.studente.sessioneOlaStudente.votoProvaFinale &&
    this.studente.sessioneOlaStudente.votoProvaFinale <
      this.studente.gruppoStudio.votoMinimoSuperamentoProvaFinale);
    const getProveEsamiDisponibili = new GetProveEsamiDisponibiliCommand();
    getProveEsamiDisponibili.idCorsoDiLaurea = this.studente.corsoLaurea.id;
    getProveEsamiDisponibili.dataCorrente = new Date();
    getProveEsamiDisponibili.idStudente = this.studente.id;
    getProveEsamiDisponibili.orale = esameEffettuato && esameSuperato;
    this.homeService
      .getProveEsamiDisponibili(getProveEsamiDisponibili)
      .subscribe(
        (result) => {
          this.provaEsameDisponibile = result.disponibili;
          this.proveEsami = result.proveEsami;
        },
        (error) => {
          console.log('Errore recupero prove esami');
        }
      );
  }

  prenotaProvaFinale() {
    if (this.provaEsameDisponibile) {
      this.ngxSmartModalService
        .getModal('prenotaProvaFinaleModal')
        .removeData();
      this.ngxSmartModalService.setModalData(
        this.proveEsami,
        'prenotaProvaFinaleModal'
      );
      this.ngxSmartModalService.getModal('prenotaProvaFinaleModal').open();
    } else {
      const text = "Attualmente non ci sono prove d'esame prenotabili!";
      this.sharedService.openWarningModal(text);
    }
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
  }



  constructor(
    public ngxSmartModalService: NgxSmartModalService,
    public router: Router,
    private spinner: NgxSpinnerService,
    private sharedService: SharedService,
    private homeService: HomeService
  ) {
    super();
  }
}
